app.factory('exportLogEntryModel', ['$rootScope', 'baseModel', 'exportLogEntryService', 'config', '$http', 'authInterceptor', '$sce', '$timeout',
    function($rootScope, baseModel, exportLogEntryService, config, $http, authInterceptor, $sce, $timeout) {

        function ExportLogEntryModel() {

            var stompClient = null;
            var socket = null;
            var self = this;
            var currentReconnections = 0;

             this.save = function(exportLogEntry) {
                return exportLogEntryService.save(exportLogEntry).then(
                    function (exportLogEntry) {
                        return exportLogEntry;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.EXPORT_LOG_ENTRY.SAVE.ERROR, error);
                    }
                )
            };

            this.getDataPage = function(criteria) {
                return exportLogEntryService.getDataPage(criteria).then(
                    function (exportLogEntry) {
                        return exportLogEntry;
                    },
                    function(error) {
                        return error;
                    }
                )
            };

            this.update = function(exportLog) {
                return exportLogEntryService.update(exportLog).then(
                    function(returnedExportLog) {
                        return returnedExportLog;
                    },
                    function(error) {
                        return error;
                    }
                )

            };

            this.downloadReceipt = function(prescriptionId) {
                //window.open(config.API_URL + '/export/' + prescriptionId + "/receipt", '_blank');

                var fileLocation = config.API_URL + '/export/' + prescriptionId + "/receipt";

                $http({
                    url: fileLocation,
                    method: "GET",
                    headers: {
                        'Content-type': 'application/json',
                        'X-AUTH-TOKEN': authInterceptor.token
                    },
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers, config) {
                    var file = new Blob([data], {type: 'application/pdf'});
                    var fileURL = URL.createObjectURL(file);
                    var link = $sce.trustAsResourceUrl(fileURL);
                    window.open(link, '_blank');
                    window.focus();
                }).error(function (data, status, headers, config) {

                });
            };

            this.downloadFile = function(logExportId) {
                window.open(config.API_URL + '/export/' + logExportId + "/download", '_blank');
            };



            this.listenOnExportComplete = function (onMessage) {
                if(!socket) {
                    socket = new SockJS(config.WS_URL + '/stomp');
                    stompClient = Stomp.over(socket);
                    stompClient.debug = null;
                    stompClient.connect({}, function(frame) {
                        currentReconnections = 0;
                        stompClient.subscribe(Constant.STOMP_CHANNELS.EXPORT_LOG, function (message) {
                            onMessage(message);
                            //stompClient.disconnect();
                        });
                    });
                }
            };


        }

        return new ExportLogEntryModel();
    }
]);
